<app-message
    [successMessage]="true"
    [messageTitle]="'messages.change-password-success.title' | translate"
    [message]="'messages.change-password-success.description' | translate"
>
</app-message>
